import React from 'react';
import { PropTypes } from 'prop-types';
import { useScreenSmDown, useScreenMinMd } from '@hooks/useResponsive';

const getIconDesktop = isActive => {
    const fill = isActive ? '#246EFF' : '#D3D0D5';
    const stroke = isActive ? '#fff' : '#000';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g fill="none" fillRule="evenodd">
                <circle cx="19.692" cy="19.692" r="19.692" fill={fill} />
                <g stroke={stroke} strokeLinecap="square" strokeWidth="1.64" transform="translate(11 10)">
                    <polygon points=".841 0 16.461 0 16.461 19.204 13.857 17.375 11.254 19.204 8.651 17.375 6.047 19.204 3.444 17.375 .841 19.204" />
                    <line x1="3.97" x2="9.65" y1="5.487" y2="5.487" />
                    <line x1="12.78" x2="13.694" y1="5.487" y2="5.487" />
                    <line x1="3.97" x2="9.65" y1="9.145" y2="9.145" />
                    <line x1="12.78" x2="13.694" y1="9.145" y2="9.145" />
                    <line x1="3.97" x2="9.65" y1="12.803" y2="12.803" />
                    <line x1="12.78" x2="13.694" y1="12.803" y2="12.803" />
                </g>
            </g>
        </svg>
    );
};

const getIconMobile = isActive => {
    const stroke = isActive ? '#246EFF' : '#1A1A1A';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16">
            <g fill="none" fillRule="evenodd" stroke={stroke} strokeLinecap="square" transform="translate(0 1)">
                <polygon points=".592 0 11.592 0 11.592 13.524 9.759 12.236 7.925 13.524 6.092 12.236 4.259 13.524 2.425 12.236 .592 13.524" />
                <line x1="2.796" x2="6.796" y1="3.864" y2="3.864" />
                <line x1="9" x2="9.644" y1="3.864" y2="3.864" />
                <line x1="2.796" x2="6.796" y1="6.44" y2="6.44" />
                <line x1="9" x2="9.644" y1="6.44" y2="6.44" />
                <line x1="2.796" x2="6.796" y1="9.016" y2="9.016" />
                <line x1="9" x2="9.644" y1="9.016" y2="9.016" />
            </g>
        </svg>
    );
};

const MenuPaymentHistory = ({ isActive = false }) => {
    const isScreenSmDown = useScreenSmDown();
    const isScreenMinMd = useScreenMinMd();

    return (
        <>
            {isScreenSmDown && getIconMobile(isActive)}
            {isScreenMinMd && getIconDesktop(isActive)}
        </>
    );
};

MenuPaymentHistory.propTypes = {
    isActive: PropTypes.bool,
};

export default MenuPaymentHistory;
